module.exports = __webpack_public_path__ + "static/media/iStock-616257726.49443490.jpg";